import { render } from "./multiselectVue.vue?vue&type=template&id=0bc811ce"
import script from "./multiselectVue.vue?vue&type=script&lang=js"
export * from "./multiselectVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__